<template>
  <div class="addprint">
    <p class="title">选择尺寸</p>
    <div class="flexwrap">
      <div class="flexitem" v-for="(item,index) in rule" :key="item.id" :class="{active:index===selindex}" @click="selindexFn(index)">
        <div class="fit">{{item.name}}</div>
        <div class="fib">{{item.width}} × {{item.height}} mm</div>
      </div>
    </div>
    <p class="title">冲印版数</p>
    <cell :cellName="`冲印版数${rule[selindex]&&rule[selindex].total?'（1版'+rule[selindex].total+'小张）：':''}`">
      <div slot="value" id="num-selector-container">
        <div class="num-selector">
          <div class="num-ctrl" @click="calcNum(-1)">-</div>
          <div class="num">{{num}}</div>
          <div class="num-ctrl" @click="calcNum(1)">+</div>
        </div>
        <div>版</div>
      </div>
    </cell>
    <p class="title">选择颜色</p>
    <div class="clrwrap" v-show="url">
        <img :src="url" class="previewimg">
        <p class="pretxt">预览图</p>
        <color-sel :coloridx="coloridx" :color="rule[selindex]&&rule[selindex].colors" @onSetidx="onSetidx"></color-sel>
    </div>
    <div class="btn" @click="addFn">加印</div>
  </div>
</template>
<script>
import Cell from "@/components/Form/Cell";
import colorSel from "@/components/colorSel";
import {Toast} from 'mint-ui'
import {mapActions,mapMutations,mapState} from "vuex";
import {createPrint} from "@/utils/utils";
export default {
  components: {
    Cell,colorSel
  },
  data(){
      return {
          coloridx:-1,
          rule:[],
          selindex:0,
          num:1,
          url:''
      }
  },
  computed:{
    ...mapState(['printextra','actiBol'])
  },
  activated(){
    console.log("yayayay:::",this.$store)
    if(!this.actiBol){
      return;
    }
    this.inimeobj()
    this.handledata()
  },
  methods:{
    ...mapMutations(['ADDGROUPLIST','SETRULECOLOR','SET_LOADING']),
    ...mapActions(['getSpecs','getAutoImage']),
    onSetidx(idx){
      if(this.coloridx===idx){
        return
      }
      this.coloridx=idx
      this.SET_LOADING(true)
      return this.makecanvas().then(res=>{
        this.url=res
        this.SET_LOADING(false)
      }).catch(err=>{
        this.SET_LOADING(false)
      })
    },
    inimeobj(){
      this.meobj={}
    },
    addFn(){
      if(this.selindex<0){
        return Toast('请选择尺寸')
      }
      if(this.coloridx<0){
        return Toast('请选择颜色')
      }
      if(!this.url){
        return Toast('图片没有制作出来呢，请重新操作')
      }
      let {colors,id,total,name} = this.rule[this.selindex]
      let {singlePrice} = this.$route.params
      let obj = {
        id,
        printQty:this.num,
        sheets_number:total,
        colorIdx:this.coloridx,
        colorName:colors[this.coloridx].color_cn,
        singlePrice,
        spec_name:name,
        image_url:this.url
      }
      this.ADDGROUPLIST(obj)
      this.$router.go(-1)
    },
    handledata(){
      this.getData().then(res=>{
        return this.getAuto(0)
      })
    },
    selindexFn(idx){
      if(idx!==undefined&&this.selindex===idx){
        return
      }
      this.getAuto(idx)
    },
    tentotwo(num){
				return num.toString(16).padStart(6,0)
			},
    makecanvas(){
      let obj = this.meobj.paibanInfo
      let {start_color,enc_color} = this.rule[this.selindex].colors[this.coloridx]
      let colors = ['#'+this.tentotwo(start_color),'#'+this.tentotwo(enc_color)]
      return createPrint(obj,colors,'请使用六寸相纸打印')
    },
    getAuto(idx){
      let {key} = this.printextra;
      let obj = {
        image_key:key
      }
      obj.spec_id=this.rule[idx].id
      return this.getAutoImage(obj).then(res=>{
        this.selindex=idx
        this.coloridx=0
        this.num=1
        this.meobj.paibanInfo=res
        console.log("res:::",res)
        return this.makecanvas()
      }).then(res=>{
        this.url = res
      }).catch(err=>{
        Toast(err)
      })
    },
    calcNum(count){
      let num = this.num
      if (num >= 20 && +count > 0) return Toast('不能再多啦！');
      if (num <= 1 && +count < 0) return Toast('亲，不能再少啦！');
      this.num=num+count
    },
    getData(){
      let {id} = this.printextra
      return this.getSpecs(id).then(res=>{
        this.rule=res
        return res[0].id
      }).catch(err=>{
        Toast('数据获取失败，请重新操作')
      })
    }
  }
};
</script>
<style scoped>
.addprint {
  min-height: 100vh;
  box-sizing: border-box;
  padding: .16rem .16rem .3rem;
}
.title {
  font-size: .16rem;
  color: #363636;
  font-weight: bold;
  margin-bottom: .14rem;
}
.flexwrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: .04rem;
}
.flexitem {
  width: 1.62rem;
  height: .72rem;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 0 .22rem;
  font-size: .12rem;
  color: #6e6e6e;
  background-color: #fff;
  border-radius: .05rem;
  margin-bottom: .12rem;
  border:.01rem solid transparent;
}
.fit {
  font-weight: bold;
  font-size: .14rem;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: .08rem;
}
.fib {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
.active {
  border: .01rem solid;
  color: #465ae0;
}
#num-selector-container {
  display: flex;
  align-items: center;
}
.num-selector {
  display: flex;
  align-items: center;
  margin-right: .08rem;
}
.num-ctrl {
  width: .14rem;
  height: .16rem;
  border: .01rem solid rgba(151, 151, 151, 0.4);
  border-radius: .01rem;
  line-height: .14rem;
  text-align: center;
}

.num {
  width: .3rem;
  text-align: center;
}
.cell{
    border-bottom: none;
    background-color: white;
    border-radius: .05rem;
    margin-bottom: .16rem;
}
.clrwrap{
    background-color: #fff;
    border-radius: .05rem;
    box-sizing: border-box;
    padding:.26rem;
}
.previewimg{
    width:1.57rem;
    height:1.08rem;
    box-shadow: 0 .02rem .04rem rgba(172, 200, 255, 0.6);
    display: block;
    margin:0 auto .08rem;
}
.pretxt{
    margin-bottom:.24rem;
    font-size: .12rem;
    color:rgba(54, 54, 54, .5);
    text-align: center;
}
.btn{
    height: .44rem;
    border-radius: .05rem;
    text-align: center;
    line-height: .44rem;
    font-size: .16rem;
    color:#fff;
    background-color: #465AE0;
    margin-top: .23rem;
}

</style>